var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.777,
    height: 18,
    viewBox: "0 0 18.777 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M16.776,6.2a.728.728,0,0,1-.262.484l-3.66,3.569.867,5.041a1.5,1.5,0,0,1,.01.2.6.6,0,0,1-.106.358.356.356,0,0,1-.308.146.814.814,0,0,1-.4-.121L8.388,13.5,3.861,15.879a.856.856,0,0,1-.4.121.366.366,0,0,1-.317-.146.6.6,0,0,1-.106-.358,1.648,1.648,0,0,1,.02-.2l.867-5.041L.252,6.684A.768.768,0,0,1,0,6.2q0-.373.565-.464L5.626,5,7.894.413Q8.086,0,8.388,0t.494.413L11.151,5l5.061.736q.565.091.565.464Z",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutline);
export default __webpack_public_path__ + "static/media/icon-star-outline.a986563a9d4e207fc8da5ced76f09dad.svg";
export { ForwardRef as ReactComponent };